/**
 * "3 for 20" bundle on the product page.
 *
 * Swapping a slot and adding the bundle to the cart. Deliberately standalone from
 * superbundle.js - the two sections never render together, and only one of the two scripts is
 * loaded per page (see index-default.html.twig).
 *
 * The 20 EUR price is applied server side: CalculatorService recognises cart lines tagged
 * "three_for_twenty" that share a bundleId and rewrites them to the target price.
 */
(function ($) {
	"use strict";

	var SECTION = ".product__superbundle.bundle-3-for-20";

	if (!$(SECTION).length) {
		return;
	}

	var $optionsContainer = $("#swap_product_container");
	var $optionsPanel = $("#swap_product_options_panel");
	var $clickedSwapButton = null;
	var cachedPools = {};
	var currentBundleProductId = "";

	/* Desktop parks the panel off-screen at right:-360px and slides it in; mobile is full width. */
	function panelSlidesIn() {
		return !isNaN(parseInt($optionsPanel.css("right"), 10));
	}

	function currentBundleIds() {
		var ids = $("[data-add-bundle-3-for-20]").data("bundleIds");

		return ids ? ids.toString().split(",") : [];
	}

	function openOptionsPanel() {
		$optionsPanel.find(".options").html("");
		$("html, body").addClass("force-noscroll");
		$optionsContainer.fadeIn(250, function () {
			if (panelSlidesIn()) {
				$optionsPanel.css({ right: "0px" });
			}
		});
		$optionsContainer.addClass("loading-overlay");
	}

	function closeOptionsPanel() {
		$("html, body").removeClass("force-noscroll");
		if (panelSlidesIn()) {
			$optionsPanel.css({ right: "-360px" });
		}
		$optionsContainer.fadeOut();
		$("#swap_product_container .search_through_panel__input").val("").trigger("keyup");
	}

	function markSelected(productId) {
		$("#swap_product_options_panel .option").removeClass("selected");
		$('#swap_product_options_panel .option[data-product-id="' + productId + '"]').addClass("selected");
	}

	function populateOptions(response) {
		$optionsPanel.replaceWith($(response.html).find("#swap_product_options_panel").css("right", 0));
		$optionsPanel = $("#swap_product_options_panel");

		$optionsContainer.removeClass("loading-overlay");
		attachFilter();
		attachOptionsEvents();
	}

	function attachOptionsEvents() {
		$("#swap_product_options_panel .option").on("click", function () {
			var newProductId = $(this).data("productId").toString();
			var bundleIds = currentBundleIds();
			var slot = bundleIds.indexOf(currentBundleProductId.toString());

			if (slot === -1) {
				closeOptionsPanel();
				return;
			}

			markSelected(newProductId);
			bundleIds[slot] = newProductId;
			closeOptionsPanel();
			requestNewBundle(bundleIds);
		});
	}

	function attachFilter() {
		var $elementsToFilter = $("#swap_product_options_panel .option");

		$("#swap_product_container .search_through_panel__input").keyup(function () {
			var searchString = $(this).val().trim().split(" ");

			Array.prototype.forEach.call($elementsToFilter, function (el) {
				var foundElement = true;

				searchString.forEach(function (text) {
					if ($(el).find(".option_name").text().toLowerCase().indexOf(text.toLowerCase()) === -1) {
						foundElement = false;
					}
				});

				$(el).toggleClass("hide", !foundElement);
			});
		});
	}

	function loadCategoryProducts() {
		currentBundleProductId = $clickedSwapButton.data("productId");

		/* The two slots offer different category tags, so each caches its own list */
		var slotKey = $clickedSwapButton.data("loopKey");

		if (typeof cachedPools[slotKey] !== "undefined") {
			openOptionsPanel();
			setTimeout(function () {
				populateOptions(cachedPools[slotKey]);
				markSelected(currentBundleProductId);
			}, 300);
			return;
		}

		openOptionsPanel();
		$.ajax({
			type: "POST",
			url: window.jstransobj.linkPrefix + "/product/category-products",
			data: {
				mode: "3for20",
				key: slotKey,
				mainProductId: $(SECTION + " .superbundle-product.main-product .listing__product").data("productId"),
				productId: currentBundleProductId,
				excludeIds: currentBundleIds()
			},
			success: function (response) {
				cachedPools[slotKey] = response;
				populateOptions(response);
				markSelected(currentBundleProductId);
			}
		});
	}

	function requestNewBundle(bundleIds) {
		$(SECTION).addClass("loading-overlay");
		$.ajax({
			type: "POST",
			url: window.jstransobj.linkPrefix + "/product/create-bundle",
			data: { bundleIds: bundleIds, template: "bundle-3-for-20" },
			success: function (response) {
				var $res = $(response.html);
				$(SECTION).html($res.html());
				/* The lists exclude the slots in use, so they have to be refetched after a swap */
				cachedPools = {};
			},
			complete: function () {
				$(SECTION).removeClass("loading-overlay");
			}
		});
	}

	function addBundleToCart($button) {
		var bundleIds = $button.data("bundleIds").toString().split(",");
		var products = {};

		bundleIds.forEach(function (id) {
			products[id] = 1;
		});

		$(SECTION).addClass("loading-overlay");

		$.ajax({
			url: window.cart_address + window.jstransobj.linkPrefix + "/cart/bundle/add",
			method: "POST",
			cache: false,
			xhrFields: { withCredentials: true },
			data: {
				products: products,
				productType: "product",
				extraParameters: {
					product: { tag: "three_for_twenty", bundleId: new Date().getTime() }
				}
			},
			success: function (response) {
				if (typeof addCustomer === "function") {
					addCustomer();
				}
				if (typeof getFromCart === "function") {
					getFromCart();
				}
				if (response.status === "success" && typeof openShoppingCart === "function") {
					openShoppingCart();
				}
				if (typeof getAddToCartPushObject === "function") {
					bundleIds.forEach(function (id) {
						getAddToCartPushObject(id, 1);
					});
				}
			},
			complete: function () {
				$(SECTION).removeClass("loading-overlay");
				if (typeof sibPush === "function" && typeof getCookie === "function") {
					sibPush(getCookie("cart"));
				}
			}
		});
	}

	if ($optionsContainer.length) {
		$(document).on("click", SECTION + ' .swap-product-button[data-bundle-mode="3for20"]', function (e) {
			e.preventDefault();
			$clickedSwapButton = $(this);
			loadCategoryProducts();
		});

		$("body").on("click", "#swap_product_container .options_header", function () {
			closeOptionsPanel();
		});

		$optionsContainer.on("click", function (e) {
			if ($(e.target).attr("id") === "swap_product_container") {
				closeOptionsPanel();
			}
		});
	}

	$(document).on("click", "[data-add-bundle-3-for-20]", function (e) {
		e.preventDefault();

		var $button = $(this);
		if ($button.hasClass("loading")) {
			return;
		}
		$button.addClass("loading");

		addBundleToCart($button);

		setTimeout(function () {
			$button.removeClass("loading");
		}, 1000);
	});
})(jQuery);
